import loadable from '@loadable/component';
import { Route, Switch, useParams } from 'react-router-dom';
import { useStoreState, useStoreActions } from 'easy-peasy';
import React, {
	useState,
	useEffect,
	useCallback,
} from 'react';

import Loading from '../../components/RepairyUIMaterials/BookingAppUI/Loading';
import Version from '../../components/RepairyUIMaterials/BookingAppUI/Version';

const BookingAppLogbook = loadable(() =>
	import ('./BookingAppService/BookingAppLogbook')
);
const BookingAppBasicService = loadable(() =>
	import ('./BookingAppService/BookingAppBasicService')
);
const BookingAppOtherService = loadable(() =>
	import ('./BookingAppService/BookingAppOtherService')
);
const Greetings = loadable(() =>
	import ('../../components/BookingApp/Greetings/Greetings')
);
const BookingAppReturningCustomer = loadable(() =>
	import ('../../components/BookingApp/BookingAppReturningCustomer')
);
const FlashMessages = loadable(() =>
	import ('../../components/RepairyUIMaterials/BookingAppUI/FlashMessages')
);
const BookingAppJobPage = loadable(() =>
	import ('../../components/BookingApp/BookingAppJobPage/BookingAppJobPage')
);
const BookingAppSummary = loadable(() =>
	import ('../../components/BookingApp/BookingAppSummary/BookingAppSummary')
);
const BookingAppConfirmationPage = loadable(() =>
	import ('../../components/BookingApp/BookingAppConfirmationPage/BookingAppConfirmationPage')
);
const AdvanceJobPage = loadable(() =>
	import ('../../components/BookingApp/AdvanceJobPage')
);
const AdvanceService = loadable(() =>
	import ('./BookingAppService/AdvanceService')
);
const TyresAndWheelsService  = loadable(() =>
	import ('./BookingAppService/TyresAndWheelsService')
);
const BookingAppStatusShort = loadable(() =>
	import ('./BookingAppStatusShort')
);

const BookingApp = (props) => {
	const { workshopCode } = useParams();
	const [isInitReady, setInitReady] = useState(false);
	const linkBuilder = (link) => {
		return ['/:workshopCode', link].join('');
	};
	const isLoading = useStoreState((state) => state.loading);
	const initStore = useStoreActions((actions) => actions.initStore);
	const onInitStore = useCallback(
		(code) =>
			initStore(code).then(() => {
				setInitReady(true);
			}),
		[initStore]
	);

	useEffect(() => {
		onInitStore(workshopCode);
	}, [workshopCode, onInitStore]);

	const isAdvance = process.env.REACT_APP_BOOKING_MODE;

	return (
		<>
			{isLoading ? <Loading /> : ''}
			<FlashMessages />
			<Version />
			<Switch>
				<Route path={linkBuilder('')} exact>
					<Greetings isInitReady={isInitReady} />
				</Route>
				<Route path={linkBuilder('/job')} exact>
					{!isAdvance && (
						<BookingAppJobPage />
					)}
					{isAdvance && (
						<AdvanceJobPage />
					)}
				</Route>
				<Route path={linkBuilder('/advance-service')}>
					<AdvanceService />
				</Route>
				<Route path={linkBuilder('/tyre-wheel')}>
					<TyresAndWheelsService />
				</Route>
				<Route path={linkBuilder('/logbook-service')}>
					<BookingAppLogbook />
				</Route>
				<Route path={linkBuilder('/basic-service')}>
					<BookingAppBasicService />
				</Route>
				<Route path={linkBuilder('/other-service')}>
					<BookingAppOtherService />
				</Route>
				<Route path={linkBuilder('/booking-summary')} exact>
					<BookingAppSummary />
				</Route>
				<Route path={linkBuilder('/booking-confirmation')} exact>
					<BookingAppConfirmationPage />
				</Route>
				<Route path={linkBuilder('/history')} exact>
					<BookingAppReturningCustomer />
				</Route>
				<Route path={linkBuilder('/:bookingShortCode')} exact>
					<BookingAppStatusShort />
				</Route>
			</Switch>
		</>
	);
};
export default BookingApp;
